import script from "./AdminUserGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserGroup.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserGroup.vue?vue&type=style&index=0&id=48531869&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48531869"]])

export default __exports__